import { render, staticRenderFns } from "./ProfileTabInfo.vue?vue&type=template&id=16f3f6b0"
import script from "./ProfileTabInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileTabInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProfileTabInfo.vue?vue&type=style&index=0&id=16f3f6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports